var angular = require('angular');

module.exports = VerifyEmailController

function VerifyEmailController($scope, $state, isVerified, errorMessage, $location){
  var originator = '';
  var existingoriginator = $location.search().originator;
  if (!existingoriginator)
    originator = '/login';
  else if(existingoriginator.indexOf('/login') !== -1)
    originator = existingoriginator
  else
    originator = '/login?redirect=' + existingoriginator

  $scope.isVerified = isVerified;
  $scope.originator = originator;
  if (errorMessage)
  {
    var errorText = errorMessage.response.text;
    var start = errorText.indexOf('message":"');
    var end = errorText.indexOf('"}');
    $scope.errorMessage = errorText.substring(start + 10, end);
    $scope.errorMessageLogin = errorText.indexOf("This email has been verified.") > -1;
  }
}
